import { Field, Input } from '@zt/ui';
import type { ApiError } from '../lib/api';
import { HelpTip } from '../lib/help';
import { useT } from '../lib/i18n';
import { useMoney } from '../lib/money';
import { usePermissions } from '../lib/session';

/** Açık hesap kredi engelleri (F7-02, ADR-105). */
export const CREDIT_CODES = ['credit_limit_exceeded', 'credit_overdue_block', 'credit_limit_currency'];

/**
 * Sipariş kredi limitine veya vadesi geçen borç kuralına takıldığında: cari yönetimi yetkisi olan kullanıcı
 * gerekçe yazarak limiti aşabilir (iki adımlı doğrulama; karar denetim kaydına yazılır). Yetkisi yoksa yalnızca
 * hata görünür.
 */
export function CreditOverrideField({
  error,
  value,
  onChange,
}: {
  error: ApiError | null;
  value: string;
  onChange: (v: string) => void;
}) {
  const t = useT();
  const money = useMoney();
  const { can } = usePermissions();
  if (!error || !CREDIT_CODES.includes(error.code) || !can('b2b.ledger.manage')) return null;
  const currency = String(error.params.currency ?? 'TRY');
  return (
    <div role="alert" className="space-y-2 rounded-sm border border-amber/30 bg-amber-tint p-3 text-sm">
      {error.code === 'credit_limit_exceeded' && (
        <p>
          {t('admin.credit.available', { amount: money(Number(error.params.availableMinor ?? 0), currency) })}
        </p>
      )}
      {error.code === 'credit_overdue_block' && (
        <p>
          {t('admin.credit.overdue', { amount: money(Number(error.params.overdueMinor ?? 0), currency) })}
        </p>
      )}
      <p>{t('admin.credit.overrideLead')}</p>
      <Field label={t('admin.credit.overrideReason')} help={<HelpTip k="orders.credit_override" />}>
        {(p) => <Input {...p} maxLength={500} value={value} onChange={(e) => onChange(e.target.value)} />}
      </Field>
    </div>
  );
}

/** Gerekçe yeterliyse istek gövdesine eklenecek alan. */
export const creditOverrideBody = (reason: string) =>
  reason.trim().length >= 3 ? { creditOverrideReason: reason.trim() } : {};
